import { useMemo } from 'react';
import '../overlays.css';

function range(n: number) { return Array.from({ length: n }, (_, i) => i); }

export default function Halloween({ intensity = 'med' }: { intensity?: string }) {
  // Fewer sprites on mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const counts = useMemo(() => {
    const baseBats = intensity === 'high' ? 24 : intensity === 'low' ? 8 : 14;
    const basePumpkins = intensity === 'high' ? 14 : intensity === 'low' ? 4 : 8;
    const scale = isMobile ? 0.6 : 1;
    return {
      bats: Math.max(4, Math.round(baseBats * scale)),
      pumpkins: Math.max(2, Math.round(basePumpkins * scale)),
    };
  }, [intensity, isMobile]);

  return (
    <div className="overlay-root" aria-hidden="true">
      {/* bats layer (top, mid, bottom) */}
      <div className="overlay-layer">
        {range(counts.bats).map((i) => {
          const delay = (Math.random() * 6).toFixed(2) + 's';
          const dur = (10 + Math.random() * 12).toFixed(2) + 's';
          const top = Math.round(Math.random() * 80) + 'vh';
          const scale = (0.6 + Math.random() * 0.8).toFixed(2);
          const flip = Math.random() < 0.5 ? -1 : 1;
          const flap = (300 + Math.round(Math.random() * 300)) + 'ms';
          return (
            <div
              key={`bat-${i}`}
              className="bat"
              style={{
                top,
                animationDelay: delay,
                animationDuration: dur,
                ['--bat-scale' as string]: scale,
                ['--bat-flap' as string]: flap,
                ['--bat-dir' as string]: flip,
              }}
            >
              {/* simple SVG bat (no external assets) */}
              <svg viewBox="0 0 64 32" className="bat-svg" aria-hidden="true">
                <path d="M2 16c10-8 16-8 30 0 14-8 20-8 30 0-8 2-12 5-13 10-7-2-11-2-17 0-1-5-5-8-13-10Z" />
                <circle cx="32" cy="16" r="2" className="bat-eye" />
                <circle cx="36" cy="16" r="2" className="bat-eye" />
              </svg>
            </div>
          );
        })}
      </div>

      {/* pumpkins drifting down softly */}
      <div className="overlay-layer">
        {range(counts.pumpkins).map((i) => {
          const left = Math.round(Math.random() * 100) + 'vw';
          const delay = (Math.random() * 8).toFixed(2) + 's';
          const dur = (14 + Math.random() * 14).toFixed(2) + 's';
          const rot = Math.round(Math.random() * 360) + 'deg';
          const drift = (Math.random() * 80 - 40).toFixed(0) + 'px';
          const size = (isMobile ? 22 : 32) + Math.round(Math.random() * 14);
          return (
            <div
              key={`pk-${i}`}
              className="pumpkin"
              style={{
                left,
                animationDelay: delay,
                animationDuration: dur,
                ['--drift' as string]: drift,
                ['--start-rot' as string]: rot,
                width: size,
                height: size,
              }}
              aria-hidden="true"
              role="img"
              aria-label="pumpkin"
            >
              {/* CSS draws it; leave empty for perf */}
            </div>
          );
        })}
      </div>
    </div>
  );
}
